import LoadingPage from './LoadingPage';
export default LoadingPage;


// WEBPACK FOOTER //
// /src/components/UiComponents/LoadingPage/index.js